<template>
  <div class="cp-set-email main">
    <div class="divider" />

    <div class="row">
      <p><i class="fa fa-tshirt icon" />Style</p>
      <p class="value">
        {{ menuStyle }}
      </p>
      <p v-if="showStyleSelector" style="margin-left: 32px; margin-top: 8px">
        <span :class="btn" @click="setStyle('instagram')"
          ><i class="fab fa-instagram fa-lg" />&nbsp;Instagram</span
        >&nbsp;
        <span :class="btn" @click="setStyle('grid')"
          ><i class="fa fa-th-large" />&nbsp;Grid</span
        >&nbsp;
        <span :class="btn" @click="setStyle('list')"
          ><i class="fa fa-list" />&nbsp;List</span
        >
      </p>
      <div class="save-wrapper">
        <span
          v-if="showStyleSelector"
          class="button is-light"
          @click="showStyleSelector = false"
        >
          Cancel
        </span>
        <span
          v-else
          class="button has-text-success"
          @click="showStyleSelector = true"
        >
          Change
        </span>
      </div>
    </div>

    <div class="divider" />

    <div class="row" @click="viewStyleInstagram">
      <p>
        <i class="fab fa-instagram fa-lg icon" />Instagram Style
        <span class="has-text-link preview">
          Preview <i class="fa fa-external-link-alt fa-sm" />
        </span>
      </p>
      <p class="value" style="margin-top: 8px">
        Best for shops with high quality images and a small number of products.
      </p>
    </div>

    <div class="divider" />

    <div class="row" @click="viewStyleGrid">
      <p>
        <i class="fa fa-th-large icon" />Grid Style
        <span class="has-text-link preview">
          Preview <i class="fa fa-external-link-alt fa-sm" />
        </span>
      </p>
      <p class="value" style="margin-top: 8px">
        Best for shops with good quality images and any number of products.
      </p>
    </div>

    <div class="divider" />

    <div class="row" @click="viewStyleList">
      <p>
        <i class="fa fa-list icon" />List Style
        <span class="has-text-link preview">
          Preview <i class="fa fa-external-link-alt fa-sm" />
        </span>
      </p>
      <p class="value" style="margin-top: 8px">
        A good choice for any kind of shop. This is the default.
      </p>
    </div>
  </div>
</template>


<script>
export default {
  name: "CPSetShopStyle",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      updatingStyle: false,
      showStyleSelector: false,
      btn: "button is-small is-rounded",
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    menuStyle() {
      if (!this.commerce.data.menu_style) return "Default";
      return this.capitaliseFirstLetter(this.commerce.data.menu_style);
    },
  },
  methods: {
    setStyle(style) {
      var obj = { menu_style: style };
      this.updatingStyle = true;
      this.$store
        .dispatch("updateWorkflowData", {
          id: this.commerce.id,
          data: obj,
        })
        .then((res) => {
          this.successToast("Updated style");
          this.commerce.data = res.data.data;
          this.showStyleSelector = false;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingStyle = false));
    },
    viewStyleInstagram() {
      this.goto(`/shop/${this.business.id}?insta=true`);
    },
    viewStyleGrid() {
      this.goto(`/shop/${this.business.id}?menu_view=grid`);
    },
    viewStyleList() {
      this.goto(`/shop/${this.business.id}?menu_view=list`);
    },
    save() {
      // save style
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  /* border-bottom: 1px dotted rgb(230, 230, 230); */
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
.preview {
  float: right;
  font-size: 0.8em;
  font-weight: 500;
  opacity: 0.7;
}
</style>
